import type { AxiosResponse } from 'axios';
import { httpWithAuth } from '~/clients';
import { INVENTORY } from '~/constants/endpoints';
import { InventoryRequest, InventoryResponse } from '~/services/contracts';

export default function fetchInventory(
  request: InventoryRequest,
  controller: AbortController
): Promise<AxiosResponse<InventoryResponse>> {
  return httpWithAuth.post<InventoryResponse>(INVENTORY, request, {
    signal: controller.signal
  });
}
